<template>
  <div class="card card-profile text-center">
   
    <div
      class="top-block"
      :style="{ backgroundImage: `url(${profile.headerImg})` }"
      v-if="user == '8290f938-b20a-42e3-c201-08d8f3241655'"
    >
      <h4 class="py-3 pt-5">{{this.profile_data[0].student_name}}</h4>
      <p class="px-5 py-3 about">
        {{ this.profile_data[0].student_class }} - ({{ this.profile_data[0].student_division }})
      </p>
    </div>
     <div
      class="top-block"
      :style="{ backgroundImage: `url(${profile.headerImg})` }"
      v-else
    >
      <h4 class="py-3 pt-5">{{ profile.name }}</h4>
      <p class="px-5 py-3 about">
        {{ profile.about }}
      </p>
    </div>

    <div class="card-block">
      <img alt="" class="card-img-profile" v-bind:src="profile.profileImg" />
    </div>

    <!-- <div class="row pb-3 ">
      <div class="col-xl-8 offset-xl-2 col-lg-10 offset-lg-1">
        <div class="row">
          <div class="col">
            <h5>Students</h5>
            <h5>{{ profile.followers }}</h5>
          </div>
          <div class="col">
            <h5>Contents</h5>
            <h5>{{ profile.following }}</h5>
          </div>
          <div class="col">
            <h5>Sharing Score</h5>
            <h5>{{ profile.notes }}</h5>
          </div>
        </div>
      </div>
    </div> -->
    <div class="row pb-3 ">
    <div class="col-xl-1"></div>
    <div class="col-xl-10">
      <table class="table tabe-bordered" style="" v-if="user == '6b82d8f3-e879-42de-a8ff-2426b61c9ab9'">
         <tr>
             <th style="text-align:left;">School Name</th><td></td><td style="text-align:left;">MH School</td>
         </tr>
         <tr>
             <th style="text-align:left;">School Email</th><td></td><td style="text-align:left;">Test@gmail.com</td>
         </tr>
         <tr>
             <th style="text-align:left;">Contact No.</th><td></td><td style="text-align:left;">7536416123</td>
         </tr>
         <tr>
             <th style="text-align:left;">Address</th><td></td><td style="text-align:left;">Adress</td>
         </tr>
      </table>
      <table class="table tabe-bordered" style="text-align:left;" v-if="user == '6b82d8f3-e879-42de-a8ff-2426b61c9ac9'">
        
      </table>
      <table class="table tabe-bordered" style="width:100%" v-if="user == '8290f938-b20a-42e3-c201-08d8f3241655'" v-for="(items,index) in profile_data" :key="index">
         <tr>
             <th style="text-align:left !important;">School Name</th><td></td><td  style="text-align:left !important;">{{items.school_name}}</td>
         </tr>
          <tr>
             <th style="text-align:left !important;">District</th><td></td><td style="text-align:left !important;">{{items.student_district}}</td>
         </tr>
         <tr>
             <th  style="text-align:left !important;">Parent Name</th><td></td><td style="text-align:left !important;">{{items.parent_name}}</td>
         </tr>
         <tr>
             <th style="text-align:left !important;">Parent Email</th><td></td><td style="text-align:left !important;">{{items.parent_email_id}}</td>
         </tr>

         <tr>
             <th style="text-align:left !important;">Parent Contact No.</th><td></td><td style="text-align:left !important;">{{items.parent_contact_number}}</td>
         </tr><tr>
             <th style="text-align:left !important;">Address</th><td></td><td style="text-align:left !important;">{{items.student_address}}</td>
         </tr>
      </table>
       <table class="table tabe-bordered" style="width:100%" v-if="content == 'Student'" v-for="(items,index) in profile_data" :key="index">
        <tr>
             <th style="text-align:left !important;">School Name</th><td></td><td  style="text-align:left !important;">{{items.school_name}}</td>
         </tr>
          <tr>
             <th style="text-align:left !important;">District</th><td></td><td style="text-align:left !important;">{{items.student_district}}</td>
         </tr>
         <tr>
             <th  style="text-align:left !important;">Parent Name</th><td></td><td style="text-align:left !important;">{{items.parent_name}}</td>
         </tr>
         <tr>
             <th style="text-align:left !important;">Parent Email</th><td></td><td style="text-align:left !important;">{{items.parent_email_id}}</td>
         </tr>

         <tr>
             <th style="text-align:left !important;">Parent Contact No.</th><td></td><td style="text-align:left !important;">{{items.parent_contact_number}}</td>
         </tr><tr>
             <th style="text-align:left !important;">Address</th><td></td><td style="text-align:left !important;">{{items.student_address}}</td>
         </tr>
      </table>
    </div>
    <div class="col-xl-1"></div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import apis from '@/apis';
const base_url=process.env.VUE_APP_BASE_URL;
export default {
   props: ["content","id"],
  data() {
    return {
      user:"",
      student_id:"",
      profile_data:[],
      profile: {
        name: localStorage.getItem('user_name'),
        about:
          "Class - 5(B)",
        profileImg: "https://joeschmoe.io/api/v1/Aruna%20Patil",
        headerImg: "http://placeimg.com/640/480/any",
        followers: "9882",
        following: "1397",
        notes: "17200",
      },
    };
  },
  name: "UserProfileCard",
  methods:{
    get_profile_data(){
      var data = {
        'student_id': this.student_id
      };
      console.log(data);
       var promise = apis.get_profile(data).then( response => {
          this.profile_data = response.data;
      }).catch( errror => {

      })
    }
  },
  components: {},
  created(){
     if(this.content == "Student"){
      this.profile.name = this.id.student_name;
      this.profile.about = "Class - 10 (B)"
      this.student_id = this.id.student_id;
      this.get_profile_data();
    }
    this.user  = localStorage.getItem('user_role_id');
      
   
    if(this.user == '8290f938-b20a-42e3-c201-08d8f3241655'){
      this.student_id  = localStorage.getItem('id');
      this.get_profile_data();
    }
    if(this.user == '6b82d8f3-e879-42de-a8ff-2426b61c9ab9'){
      this.profile.about = "MH School Affliated to MahaVidya"
    }
    if(this.user == '6b82d8f3-e879-42de-a8ff-2426b61c9ac9' && this.content != 'Student'){
      this.profile.about = "Welcome To Super Admin Panel"
    }
  }
};
</script>

<style scoped>
.card-profile {
  width: 100%;
  background-color: #e5e5e5;
  border-radius: 0;
  border: 0;
}
.card-profile .card-img-top {
  border-radius: 0;
}
.card-profile .card-img-profile {
  max-width: 150px;
  border-radius: 50%;
  margin-top: -95px;
  margin-bottom: 35px;
  border: 5px solid #e6e5e1;
}

.top-block {
  height: 300px;
  color: #fff;
  background-repeat: no-repeat;
  background-size: cover;
}

.top-block .about {
  font-size: 1.1em;
}
</style>
